import {Injectable} from '@angular/core';

@Injectable({providedIn: 'root'})
export class cookie {

    isConsented = false;

    constructor() {}

    /**
     * delete cookie
     * @param name
     */
    public deleteCookie(name : string, domain : string = '') {
        this.setCookie(name, null, -1, '/', domain);
    }

    /**
     * get cookie
     * @param name
     * @returns
     */
    public getCookie(name : string) {
        const ca: Array<string> = document.cookie.split(';');
        const caLen: number = ca.length;
        const cookieName = `${name}=`;
        let c: string;

        for (let i = 0; i < caLen; i += 1) {
            c = ca[i].replace(/^\s+/g, '');
            if (c.indexOf(cookieName) === 0) {
                return c.substring(cookieName.length, c.length);
            }
        }
        return '';
    }

    /**
     * set cookie
     * @param name
     * @param value
     * @param expireDays
     * @param path
     */
    public setCookie(name : string, value : string, expireDays : number = 60, path : string = '/', domain : string = '') {

        const d: Date = new Date();

        let expires = '';
        if (expireDays) {
            d.setTime(d.getTime() + expireDays * 24 * 60 * 60 * 1000);
            expires = `expires=${
                d.toUTCString()
            }`;
        }

        const cpath = path ? `; path=${path}` : '';
        const cdomain = domain ? `; domain=${domain}` : '';
        document.cookie = `${name}=${value}; ${expires}${cpath}${cdomain}`;
    }

    /**
     * consent
     * @param isConsent
     * @param e
     * @param COOKIE
     * @param EXPIRE_DAYS
     * @returns
     */
    public consent(isConsent : boolean, e : any, COOKIE : string, EXPIRE_DAYS : number) {
        if (!isConsent) {
            return this.isConsented;
        } else if (isConsent) {
            this.setCookie(COOKIE, '1', EXPIRE_DAYS);
            this.isConsented = true;
            e.preventDefault();
        }
    }

}
